import { Component } from '@angular/core';
import { AnalyticsService } from '@core/application';

@Component({
  selector: 'app-root',
  styleUrls: [],
  template: '<router-outlet><router-outlet>',
})
export class AppComponent {
  title = 'checkplus-web-app';

  constructor(analytics: AnalyticsService) {
    analytics.startPageViewTracking();
  }
}
